import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  IChangeSignFieldPriorityEvent,
  IChangeSignFieldTypeEvent,
} from '@app/transaction-builder/model/sign-field-events.model';
import { IClientSignField } from '@app/transaction-builder/model/sign-field.model';
import { ITxFormClientData } from '@app/transaction-builder/model/transaction-form-data.model';
import { SignatureType } from 'ngx-mat-esign360';

@Component({
  selector: 'app-doc-editor-side-panel',
  templateUrl: './doc-editor-side-panel.component.html',
  styleUrls: ['./doc-editor-side-panel.component.scss'],
})
export class DocEditorSidePanelComponent implements OnInit {
  @Input() signers: ITxFormClientData[];
  @Input() activeSigner: ITxFormClientData;
  @Input() signFields: IClientSignField[];
  @Input() activeSignField: IClientSignField;
  @Input() showSignFieldPriority: boolean;
  @Output() clickSigner = new EventEmitter<ITxFormClientData>();
  @Output() clickSignField = new EventEmitter<IClientSignField>();
  @Output() deleteSignField = new EventEmitter<IClientSignField>();
  @Output() changeSignFieldType = new EventEmitter<IChangeSignFieldTypeEvent>();
  @Output() changeSignFieldPriority = new EventEmitter<IChangeSignFieldPriorityEvent>();
  signFieldsExpansionMap: { [clientId: string]: boolean } = {};
  SignatureType = SignatureType;

  constructor() {}

  ngOnInit(): void {}

  toggleSignFieldList(signer: ITxFormClientData): void {
    this.signFieldsExpansionMap[signer.personalId] =
      !this.signFieldsExpansionMap[signer.personalId];
  }
}
